import Box from "@mui/material/Box";
import type { ColumnDef } from "@tanstack/react-table";

import type { DriverRow } from "@/types/driver";
import { sanitizeHtmlForDisplay } from "@/utils/sanitizeHtmlForDisplay";
import { zinc } from "../ui/colors";
import { minWidthForColumnHeader } from "./columnMinWidth";

const RECENT_MESSAGE_COLUMN_TITLE = "Most Recent Driver Message";

export function recentMessageColumn(): ColumnDef<DriverRow> {
  return {
    accessorKey: "recentMessage",
    header: RECENT_MESSAGE_COLUMN_TITLE,
    cell: ({ getValue }) => {
      const value = getValue<string | null>();
      const html = sanitizeHtmlForDisplay(value ?? "");
      return (
        <Box
          className="display-transcript"
          component="div"
          dangerouslySetInnerHTML={{ __html: html }}
          sx={{
            color: zinc[400],
            display: "-webkit-box",
            fontSize: "0.875rem",
            maxHeight: "2.75rem",
            overflow: "hidden",
            wordBreak: "break-word",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
          }}
        />
      );
    },
    meta: { flex: 2, draggable: true },
    minSize: minWidthForColumnHeader(RECENT_MESSAGE_COLUMN_TITLE, { draggable: true, hasFilter: false }),
    enableSorting: false,
    enableGlobalFilter: false,
  };
}
